import React from "react";
import { Modal } from "antd";
import { t } from "i18next";
import { InputText, Form, Button, SelectInput, Spin } from "common/elements";
import { getOne, insertNewRecord, updateRecordById } from "services/team";
import { getMany } from "services/department";

export default class FormModal extends React.PureComponent {
  state = {
    isModalVisible: false,
    id: null,
    departments: [],
    loading: false,
    disabled: false,
    loadingFormData: false,
  };

  componentDidMount() {
    getMany({offset:0,limit:0}).then((response) => {
      if (response) {
        this.setState({ departments: response.data });
      }
    }).catch(error => {
      if (error.response.status === 403) {
        localStorage.removeItem("ACCESS_TOKEN");
        this.props.navigate("/signin");
      }
    })
  }

  showModal = (id) => {
    if (id) {
      this.setState({ loadingFormData: true, isModalVisible: true });
      getOne(id)
        .then((response) => {
          if (response) {
            const formData = response.data;
            this.props.form.setFieldsValue({
              name: formData.name,
              departmentId: parseInt(formData.departmentId),
            });
          }
        }).catch(error => {
          if (error.response.status === 403) {
            localStorage.removeItem("ACCESS_TOKEN");
            this.props.navigate("/signin");
          }
        })
        .finally(() => {
          this.setState({
            isModalVisible: true,
            id,
            loadingFormData: false,
          });
        });
    } else {
      this.setState({
        isModalVisible: true,
        id: null,
      });
    }
  };

  handleCancel = () => {
    this.props.form.resetFields();
    this.setState({
      isModalVisible: false,
      disabled: false,
    });
  };

  onFinish = (values) => {
    this.setState({ loading: true, disabled: true });
    if (this.state.id) {
      updateRecordById(this.state.id, values)
        .then(() => {
          this.setState({
            isModalVisible: false,
          });
          this.props.form.resetFields();
          this.props.onSuccess();
        })
        .finally(() => {
          this.setState({ loading: false, disabled: false });
        });
    } else {
      insertNewRecord(values)
        .then(() => {
          this.setState({
            isModalVisible: false,
          });
          this.props.form.resetFields();
          this.props.onSuccess();
        })
        .finally(() => {
          this.setState({ loading: false, disabled: false });
        });
    }
  };

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  render() {
    const {
      departments,
      isModalVisible,
      loading,
      loadingFormData,
      disabled,
      id,
    } = this.state;
    return isModalVisible ? (
      <Modal
        title={id ? t("text_edit_team") : t("text_new_team")}
        visible={isModalVisible}
        onCancel={this.handleCancel}
        style={{ top: 20 }}
      >
        <Spin spinning={loadingFormData}>
          <Form
            form={this.props.form}
            onFinish={this.onFinish}
            layout="vertical"
            onFinishFailed={this.onFinishFailed}
            key={id}
          >
            <InputText
              name="name"
              label={t("text_name")}
              placeholder={t("text_what_is_your_team_name")}
              requiredMessage={t("text_please_input_team_name")}
              isAutoSelect={true}
            />
            <SelectInput
              name="departmentId"
              label={t("text_department")}
              placeholder={t("text_select_department")}
              errorMessage={t("text_please_select_department")}
              valueKey="id"
              required={true}
              isAutoSelect={true}
              dataSource={departments}
            />
            <div className="ant-modal-footer2">
              <Button
                className="btn-cancel"
                onClick={this.handleCancel}
                disabled={disabled}
              >
                {t("text_cancel")}
              </Button>
              <Button
                className="btn-save"
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                {t("text_save")}
              </Button>
            </div>
          </Form>
        </Spin>
      </Modal>
    ) : (
      <div />
    );
  }
}
